<template>

    <transition name="slide-width-fade">
        <div class="bg-green-dark absolute bottom-16 left-14 justify-between z-20 p-10"
            v-if="$root.showAccount && $root.showMenu">
            <div class="absolute top-3 right-3">
                <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"
                    class="block w-3 h-3 mx-auto stroke-current text-white cursor-pointer"
                    v-on:click="$root.showAccount = !$root.showAccount"
                >
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path d="M11.689,23.25.97,12.53a.749.749,0,0,1,0-1.06L11.689.75" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                        <path d="M22.939,23.25,12.22,12.53a.749.749,0,0,1,0-1.06L22.939.75" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"></path>
                    </g>
                </svg>
            </div>

            <div class="relative">
                <div class="mx-2 mb-2">
                    <div class="font-medium text-base text-white">
                        <inertia-link :href="route('app.profile.index')" class="text-sm text-white hover:text-gray-400"
                        >
                            {{ $page.props.auth.user.first_name }} {{ $page.props.auth.user.last_name }}
                        </inertia-link>
                    </div>
                </div>

                <!-- Logout -->
                <div class="mx-2 my-2">
                    <inertia-link :href="route('logout')" method="post" as="button" class="text-sm text-white hover:text-gray-400">Log Out</inertia-link>
                </div>
            </div>
        </div>
    </transition>

</template>

<script>

    export default {
        data() {
            return {
            }
        },
    }
</script>
